import _ from 'lodash/fp';

const filterConfig = {
  filter(community, { values }) {
    return (values || [])
      .map(v => v.value)
      .includes(community._id);
  },
  collectValues(communities) {
    const communityNames = _.flow(
      _.sortBy('name'),
      _.map(community => ({
        value: community._id,
        community,
      })),
    )(communities);

    return communityNames;
  },
  labelRender: ({ community }) => _.get('name', community),
};

export default filterConfig;



// WEBPACK FOOTER //
// ./src/filters/Communities/Community.js